// extracted by mini-css-extract-plugin
export var currencyInput = "_ne-1";
export var currencySymbol = "_ne-0";